(function ($) {
    'use strict';
    $(document).ready(function () {
        $("#csl_import_example").click(function () {
            var type = $(this).closest(".import_collection_widget").find("select").val();
            var example = $(this).data('example');
            // location.href = example[type];
            window.open(example[type]);
        });
    });
})(jQuery);